<template>
  <div>
    <div class="max-w-sm mx-auto border rounded-lg md:mx-4 dark:border-gray-700">
      <div class="p-6">
        <h1 class="text-xl font-medium text-gray-700 capitalize lg:text-3xl dark:text-white">{{pricing_details.name}}</h1>

        <p class="mt-4 text-gray-500 dark:text-gray-300">
          {{pricing_details.description}}
        </p>

        <h2 class="mt-4 text-2xl font-medium text-gray-700 sm:text-4xl dark:text-gray-300">{{`£ ${pricing_details.price || pricing_details.charges[0].price}`}}</h2>

        <p class="mt-1 text-gray-500 dark:text-gray-300">
          Setup Charge <span>{{`£ ${pricing_details.setup_charge || pricing_details.charges[0].setup_charge}`}}</span>
        </p>

        <button class="text-black w-full px-4 py-2 mt-6 tracking-wide text-white capitalize bg-primary duration-200 transform rounded-md border-0">
          Start Now
        </button>
      </div>

      <hr class="border-gray-200 dark:border-gray-700">

      <div class="p-6">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. A, accusantium doloribus enim fuga fugiat id labore nam odit pariatur rem repellendus repudiandae sapiente sit. Blanditiis cum dolor iusto quis? Perferendis.

<!--        <h1 class="text-lg font-medium text-gray-700 capitalize lg:text-xl dark:text-white">What’s included:</h1>-->

<!--        <div class="mt-8 space-y-4">-->
<!--          <div class="flex items-center">-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor">-->
<!--              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />-->
<!--            </svg>-->

<!--            <span class="mx-4 text-gray-700 dark:text-gray-300">All limited links</span>-->
<!--          </div>-->

<!--          <div class="flex items-center">-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor">-->
<!--              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />-->
<!--            </svg>-->

<!--            <span class="mx-4 text-gray-700 dark:text-gray-300">Own analytics platform</span>-->
<!--          </div>-->

<!--          <div class="flex items-center">-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor">-->
<!--              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />-->
<!--            </svg>-->

<!--            <span class="mx-4 text-gray-700 dark:text-gray-300">Chat support</span>-->
<!--          </div>-->

<!--          <div class="flex items-center">-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor">-->
<!--              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />-->
<!--            </svg>-->

<!--            <span class="mx-4 text-gray-700 dark:text-gray-300">Optimize hashtags</span>-->
<!--          </div>-->

<!--          <div class="flex items-center">-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">-->
<!--              <path fill-rule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clip-rule="evenodd" />-->
<!--            </svg>-->

<!--            <span class="mx-4 text-gray-700 dark:text-gray-300">Mobile app</span>-->
<!--          </div>-->

<!--          <div class="flex items-center">-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">-->
<!--              <path fill-rule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clip-rule="evenodd" />-->
<!--            </svg>-->

<!--            <span class="mx-4 text-gray-700 dark:text-gray-300">Unlimited users</span>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingTierCardView",
  props: {
    pricing_details: {
      type: Object
    }
  },

  computed: {
    pricing_tier_details: function () {
      return this.pricing_details
    }
  }
}
</script>

<style scoped>

</style>
